import React from "react";
import styled from "styled-components";
import { EmployeeBlock } from "Blocks";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { BlockContainer } from "BaseComponents/Wrappers";

import { Ingress } from "BaseComponents/Text";
export const EmployeeListBlock = ({ Heading, Preamble, Contacts, BackgroundColor }) => {
	return (
		<BlockContainer>
			<OuterWrapper>
				<TopWrapper>
					<H2>{Heading}</H2>
					{Preamble && (
						<Ingress maxWidth="615px" normal>
							{Preamble}
						</Ingress>
					)}
				</TopWrapper>
				<InnerWrapper>
					{Contacts.map((contact, key) => {
						return (
							<EmployeeBlock
								bgColor={BackgroundColor}
								key={key}
								contact={contact}
							/>
						);
					})}
				</InnerWrapper>
			</OuterWrapper>
		</BlockContainer>
	);
};
export const OuterWrapper = styled.div`
	max-width: 1280px;
	margin: 0 auto;
	/* padding: 0 1rem; */
`;
export const TopWrapper = styled.div`
	margin-bottom: 25px;
`;
const InnerWrapper = styled.div`
	margin-bottom: 25px;
	flex-wrap: wrap;
	margin: 0 0 0 -15px;

	display: flex;
	${media.lessThan(breakpoints.mobile)`
	flex-direction: column;
	
	`}
`;
const H2 = styled.h2`
	margin-bottom: 10px;
	font-family: ${({ theme }) => theme.font};
	font-size: 24px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
`;
